<div class="row-body">
  <div class="row-name" [title]="name">{{ name }}</div>
  <div class="row-bar">
    <div class="bar-track">
      <div class="bar-fill" [style.width.%]="barWidth"></div>
    </div>
  </div>
  <div class="row-count">
    <ng-container *ngIf="valueFormat === 'count'">{{
      value | thousandSuff
    }}</ng-container>
    <ng-container *ngIf="valueFormat === 'percent'">{{
      value >= 0.01 ? (value | percent) : (value | percent: '1.0-1')
    }}</ng-container>
  </div>
  <div
    class="delta-pill"
    [class.positive]="deltaClass === 'positive'"
    [class.negative]="deltaClass === 'negative'"
    [class.neutral]="deltaClass === 'neutral'"
  >
    <span class="arrow" *ngIf="deltaArrow">{{ deltaArrow }}</span>
    <span class="value">{{ deltaLabel }}</span>
  </div>
</div>

<div class="microchart-container" *ngIf="showSparkline">
  <app-micro-chart
    [seriesData]="series"
    [timeframe]="microTimeframe"
  ></app-micro-chart>
</div>

<div class="event-analytics-container" *ngIf="showTemporality">
  <app-event-analytics-temporality
    [widths]="temporalityWidths"
  ></app-event-analytics-temporality>
</div>
